import { Control, useController, FieldPathByValue, FieldValues } from "react-hook-form";
import DateInput from "@/components/DateInput";

interface SingleDatePickerProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  label: string;
  required?: boolean;
  name: FieldPathByValue<TFieldValues, string>;
  supportingText?: string;
  useModal?: boolean;
}

export default function SingleDatePicker<TFieldValues extends FieldValues>({
  control,
  label,
  required = false,
  name,
  supportingText,
  useModal = false
}: SingleDatePickerProps<TFieldValues>) {
  const {
    field: { onChange, value, onBlur },
    fieldState: { error }
  } = useController({ control, name, rules: { required: required ? `${label} is required` : undefined } });

  return (
    <DateInput
      label={required ? `${label} *` : label}
      value={value || null}
      onChange={(next) => onChange(next ?? "")}
      onBlur={onBlur}
      supportingText={supportingText}
      error={!!error}
      errorMessage={error?.message}
      useModal={useModal}
    />
  );
}
